export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", async () => {
    try {
      const registration = await navigator.serviceWorker.register("/service-worker.js");
      console.log("[SW] registered", registration);

      // first check
      await registration.update();

      // local testing: every 5 sec
      // production: make it 60000
      setInterval(async () => {
        console.log("[SW] checking for update...");
        try {  
            
          await registration.update();
        } catch (e) {
          console.error("[SW] update check failed", e);
        }
      }, 5000);

      // if already waiting from previous update
      if (registration.waiting) {
        console.log("[SW] waiting worker already exists");
        notifyUpdate(registration);
      }

      registration.addEventListener("updatefound", () => {
        console.log("[SW] updatefound fired");

        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener("statechange", () => {
          console.log("[SW] new worker state:", newWorker.state);

          if (
            newWorker.state === "installed" &&
            navigator.serviceWorker.controller
          ) {
            console.log("[SW] new version installed and waiting");
            notifyUpdate(registration);
          }
        });
      });

      // popup-only mode -> no reload
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        console.log("[SW] controller changed");
      });

    } catch (error) {
      console.error("[SW] registration failed:", error);
    }
  });
}

function notifyUpdate(registration) {
  console.log("[SW] notifyUpdate called");

  const waitingWorker = registration.waiting;
  if (!waitingWorker) {
    console.log("[SW] no waiting worker found");
    return;
  }

  const messageChannel = new MessageChannel();

  messageChannel.port1.onmessage = (event) => {
    console.log("[SW] version message received:", event.data);

    if (event.data?.type === "SW_VERSION") {
      window.dispatchEvent(
        new CustomEvent("ERP_UPDATE_AVAILABLE", {
          detail: {
            version: event.data.version,
          },
        })
      );
    }
  };

  // ask waiting SW for its version
  waitingWorker.postMessage({ type: "GET_VERSION" }, [messageChannel.port2]);
}